export default "__VITE_PUBLIC_ASSET__83dce484__"